import Project from "./project"
import Department from "./department"
import InventoryItem from "./inventory-item"
import TransactionAccount from "./transaction-account"
import ProjectTask from "./project-task"
import Branch from "./branch"

export class TransactionUI {
    static amountColor(value: number): string {
        if (value >= 0)
            return 'success'

        return 'error'
    }
}

export default interface Transaction {
    id: string
    projectId?: string | null
    branchId?: string | null
    departmentId?: string | null
    inventoryId?: string | null
    transactionAccountId?: string | null
    taskId?: string | null
    amount: number
    fiscalPeriod: number
    billable: boolean
    createdAt: Date

    // Navigation
    project?: Project
    department?: Department
    inventoryItem?: InventoryItem
    transactionAccount?: TransactionAccount
    task?: ProjectTask
    branch?: Branch
}
